import React from 'react'
import classnames from 'classnames'
import { LoadingSVG } from 'assets/svg'
import './Button.scss'

interface ButtonProps {
  children: React.ReactNode
  onClick?: React.MouseEventHandler<HTMLButtonElement>
  type?: 'button' | 'submit' | 'reset'
  disabled?: boolean
  additionLoadingText?: string
  color?:
    | 'green'
    | 'green outline'
    | 'red'
    | 'red outline'
    | 'blue'
    | 'blue outline'
    | 'dark-blue'
    | 'dark-blue outline'
    | 'dark'
    | 'dark outline'
  className?: string
  loading?: boolean
  id?: string
}

/**
 * Use `Button` as primary button element.
 */
const Button = ({
  children,
  onClick,
  type = 'button',
  additionLoadingText = " ",
  disabled = false,
  color = 'green',
  className,
  loading = false,
  id,
  ...rest
}: ButtonProps) => {
  return (
    <button
      type={type}
      onClick={loading ? undefined : onClick}
      disabled={disabled || loading}
      className={classnames('v3-button', color, className, { loading })}
      id={id}
      {...rest}
    >
      {loading ? (
        <>
          <LoadingSVG size="24" />
          <span style={{ marginLeft: '8px' }}>{additionLoadingText}</span>
        </>
      ) : children}
    </button>
  )
}

export default Button
